import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useRef } from "react";
import { MoviesSlider } from "./moviesList";
import { BackBarButtonMini } from "../common/backBarButton";
import smoothScroll from "../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../utils/focusScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";
import LazyRow from "../common/LazyRow";

var CategoriesContent = function (props) {
  var data = props.data || {};

  var focusableResult = useFocusable();
  var ref = focusableResult.ref;
  var focusKey = focusableResult.focusKey;

  var contents = data.contents;
  var children = data.children;

  var hasContentfulItem = useRef({ current: false });

  if (contents && contents.length > 0) {
    contents.forEach(function (item) {
      if (item.data && item.data.length > 0) {
        hasContentfulItem.current = true;
      }
    });
  }

  var inputModeResult = useInputMode();
  var isMouseFocus = inputModeResult.isMouseFocus;
  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      var targetScroll = getVerticalFocusScrollTarget(ref.current, focusProps || {}, {
        topPadding: 88,
        bottomPadding: 128,
      });

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <div className="legacy-parent-content">
      <FocusContext.Provider value={focusKey}>
        <div className="legacy-parent-scroll" ref={ref}>
          <div className="legacy-paged-header legacy-paged-header-indented">
            <BackBarButtonMini />
            <h2 className="legacy-paged-title">{data?.result?.name}</h2>
          </div>
          {/* Only show children categories, not the parent's self-content */}
          {hasContentfulItem.current === true ? (
            contents
              .filter(function (x) {
                return x.key !== data.result.slug;
              })
              ?.map(function (item, index) {
                var childMeta = children?.find(function (x) {
                  return x.key === item.key;
                });
                var title = childMeta?.meta?.bin?.name;
                if (item.data && item.data.length > 0) {
                  return (
                    <LazyRow index={index} key={item.key}>
                      <MoviesSlider
                        movies={item.data}
                        rowTitle={title}
                        onFocus={onRowFocus}
                        shouldFocusSelf={index === 0}
                        id={item.key}
                        nextPlayGuide={{
                          type: "category",
                          slug: item.key,
                          name: title || "",
                        }}
                      />
                    </LazyRow>
                  );
                } else {
                  return null;
                }
              })
          ) : (
            <div className="legacy-paged-empty">
              <span className="legacy-paged-empty-text">محتوایی یافت نشد</span>
            </div>
          )}
        </div>
      </FocusContext.Provider>
    </div>
  );
};

export default CategoriesContent;
